import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import scrollToTop from '../../../utils/scrollToTop';

export interface ScrollToTopProps extends RouteComponentProps<{}> {}

export interface ScrollToTopState {
  /* empty*/
}

export class ScrollToTopBase extends React.Component<
  ScrollToTopProps,
  ScrollToTopState
> {
  componentDidUpdate(prevProps: RouteComponentProps<{}>) {
    if (this.props.location !== prevProps.location) {
      scrollToTop(200);
    }
  }

  render() {
    return this.props.children || null;
  }
}

export const ScrollToTop = withRouter(ScrollToTopBase);
export default ScrollToTop;



// WEBPACK FOOTER //
// ./src/app/components/Utils/ScrollToTop/index.tsx